import { _ as r } from "./atoms-v21299.js";
var a = r, o = a["__core-js_shared__"], s = o;
export {
  s as _
};
